import { render, staticRenderFns } from "./SwitchReservation.vue?vue&type=template&id=01e1e013&scoped=true&"
import script from "./SwitchReservation.vue?vue&type=script&lang=js&"
export * from "./SwitchReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e1e013",
  null
  
)

export default component.exports